import { END_POINTS } from "../constants/urls";
import { CommonBody, CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

// interface CommonResponseType {
//   status: number;
//   message: string;
//   statusCode: number;
// }

// interface PostLoginBody {
//   email: string;
//   password: string;
// }

export const boostPlans = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBoostPlans: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        limit?: number;
        page?: number;
        parentId?: string;
        status?: boolean;
        isBlocked?: boolean;
      }
    >({
      query: ({ page, limit, search, isBlocked, status, parentId }) => ({
        url: `${END_POINTS.getBoostPlans}?page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }${isBlocked ? `&isBlocked=${isBlocked}` : ""}${
          status ? `&status=${status}` : ""
        }${parentId ? `&parentId=${parentId}` : ""}`,
        method: "GET",
      }),
    }),
    getBoostPlanDropDownList: builder.query<
      CommonResponseType & { data: any },
      { categoryId?: string }
    >({
      query: ({ categoryId }) => {
        return {
          url: `${END_POINTS.getBoostPlansDropDownList}${
            categoryId ? `?categoryId=${categoryId}` : ""
          }`,
          method: "GET",
        };
      },
    }),
    getBoostPlansById: builder.query<CommonResponseType & { data: any }, {}>({
      query: (id) => ({
        url: `${END_POINTS.getBoostPlansById}/${id}`,
        method: "GET",
      }),
    }),
    addBoostPlans: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addBoostPlans,
        method: "POST",
        body,
      }),
    }),
    updateBoostPlans: builder.mutation<
      CommonResponseType,
      { body: any; id: any }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateBoostPlans}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteBoostPlans: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteBoostPlans}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetBoostPlansQuery,
  useDeleteBoostPlansMutation,
  useUpdateBoostPlansMutation,
  useAddBoostPlansMutation,
  useGetBoostPlanDropDownListQuery,
  useLazyGetBoostPlansByIdQuery,
} = boostPlans;
